



























import Vue from 'vue';
import {Theme} from '@/models';

export default Vue.extend({
  name: 'ErrorView',
  computed: {
    currentTheme(): Theme {
      return this.$store.state.themes.current;
    },
  },
  created() {
    if (!this.$route.params.errorMessageKey) {
      this.$router.push({name: 'home'});
    }
  },
});
